import React, { useState, useRef, useEffect } from 'react'
import { gsap } from 'gsap'
import constants from '../constants'
import Store from '../store'
import raf from 'raf'
import scrolltop from 'simple-scrolltop'

const MenuMobile = ({className}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [currentAnchor, setCurrentAnchor] = useState()
  const [isBarOpen, setIsBarOpen] = useState(false)
  const plusBtnSize = 21
  let topBarMenu = useRef(null)

  const plusBtnEl = useRef()
  const activeMenuItem = (e) => {
    setIsMenuOpen(false)
  }

  const menuOpen = () => {
    setIsMenuOpen(true)
  }

  const menuClose = () => {
    setIsMenuOpen(false)
  }

  useEffect(() => {
    const toggleMenuItem = () => {
      raf(() => {
        let scrollDistance = scrolltop()
        let welcomeSection = document.querySelector(`.welcome-section`)
        if (scrollDistance > welcomeSection.offsetHeight) {
          setIsBarOpen(true)
        } else {
          setIsBarOpen(false)
        }
      })
    }
    const onChangeAnchor = (id) => {
      // console.log(`anchor change`, id)
      const current = constants.DATES.filter(item => item.anchor === id)[0]
      if (current) setCurrentAnchor(current)
    }
    Store.on(constants.CHANGE_ANCHOR, onChangeAnchor)
    document.addEventListener('scroll', toggleMenuItem)
    return () => {
      Store.off(constants.CHANGE_ANCHOR, onChangeAnchor)
      document.removeEventListener('scroll', toggleMenuItem)
    }
  }, [])
  useEffect(() => {
    if (isMenuOpen) {
      gsap.to(plusBtnEl.current, { rotate: `135deg`, duration: 0.5, ease: `expo.out` })
    } else {
      gsap.to(plusBtnEl.current, { rotate: `0deg`, duration: 0.5, ease: `expo.out` })
    }
  }, [isMenuOpen])
  const GoldCircle = ({ active=true }) => (
    <div className={`tw-w-1/12`}>
      <div className={`tw-bg-gold tw-block tw-w-3 tw-h-3 tw-rounded-full tw-float-right ${active ? `tw-opacity-100` : `tw-opacity-0`}`} />
    </div>
  )
  const GoldLine = ({ active=true }) => (
    <div className={`tw-w-2/12 tw-px-2`}>
      <div className={`tw-bg-gold tw-block tw-h-px ${active ? `tw-opacity-100` : `tw-opacity-0`}`} />
    </div>
  )
  const DateAndText = ({ className, date, text, isHome }) => (
    <div className={`${className} tw-flex tw-items-center`}>
      { date && <div className={`tw-text-gold tw-mr-2 tw-text-xs tw-font-sans`}>{date}</div>}
      <div className={`${isHome ? `tw-text-red tw-text-sm` : `tw-text-gray-600`} tw-truncate tw-uppercase tw-font-sans`}>{text}</div>
    </div>
  )

  const dates = constants.DATES.map((item, index) => {
    return (
      <li className={`${constants.heading} tw-text-gray-600 tw-antialised tw-flex tw-relative`} key={`date-${index}-${item}1`}>
          <div className={`tw-flex tw-items-center tw-w-full tw-justify-start tw-py-2`}>
            <GoldCircle active={false} />
            <GoldLine active={false} />
            <div className={`tw-w-9/12 tw-flex tw-font-sans`}>
              <DateAndText
                className={`tw-w-10/12`}
                date={item.data}
                text={item.text}
              />
            </div>
          </div>
          <a href={item.anchor ? `#${item.anchor}` : `#${item.data}`} className={`tw-w-full tw-h-full tw-absolute`} onClick={activeMenuItem} data-index={index} />
      </li>
    )
  })
  // console.log('menu-mobile refresh', isBarOpen, isMenuOpen, currentAnchor)
  const headerH = 54
  return (
    <menu className={`${className} tw-font-sans`} id={`sidebar-mobile-menu`}>
      <div
        onClick={() => isMenuOpen ? menuClose() : menuOpen()}
        ref={(el) => (topBarMenu = el)}
        className={`mobile-menu-header tw-fixed tw-top-0 tw-left-0 tw-z-50 tw-w-full tw-h-auto tw-transform tw-transition-all tw-duration-300 tw-out-expo tw-bg-gray tw-overflow-hidden`}
        style={{
          height: isMenuOpen ? `${100}%` : `${headerH}px`,
          clipPath: `inset(0px 0px ${isMenuOpen ? `0px` : `calc(100% - ${headerH}px)`} 0px)`,
          transform: `translateY(${isBarOpen ? 0 : -headerH}px)`
        }}
      >
        <div
          className={`${constants.heading} tw-w-full tw-py-2 tw-flex tw-items-center tw-fixed tw-z-40 tw-top-0 tw-left-0`}
          style={{
            boxShadow: `0px 7px 10px -1px rgba(0, 0, 0, 0.15)`,
            height: `${headerH}px`
          }}
        >
          <GoldCircle />
          <GoldLine />
          <div className={`tw-w-9/12 tw-flex`}>
            { currentAnchor &&
            <DateAndText
              className={`tw-w-10/12`}
              date={currentAnchor.data}
              text={currentAnchor.text}
            />
            }
            <div className={`tw-w-2/12`}>
              <div style={{ width: `${plusBtnSize}px`, height: `${plusBtnSize}px` }} className={`tw-absolute tw-transform tw-translate-x-1/2 tw--translate-y-1/2 tw-top-1/2 tw-right-6`}>
                <div ref={plusBtnEl} className={`tw-inline-flex tw-flex-col tw-justify-evenly tw-items-center tw-w-full tw-h-full`}>
                  <span className={`tw-w-full tw-h-px tw-bg-gray-600 tw-absolute`} />
                  <span className={`tw-w-px tw-h-full tw-bg-gray-600`} />
                </div>
              </div>
            </div>
          </div>
        </div>
        { isMenuOpen &&
        <div
          className={`tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-screen tw-z-50 tw-overflow-y-auto tw-overflow-x-hidden`}
          style={{
            zIndex: 60,
            top: `${headerH}px`
          }}
        >
          <ul className={`tw-pt-16 tw-pb-32`}>
            <li className={`${constants.heading} tw-text-gray-600 tw-antialised tw-flex tw-relative`}>
              <div className={`tw-flex tw-items-center tw-w-full tw-justify-start tw-py-2 tw-text-gold`}>
                <GoldCircle active={false} />
                <GoldLine active={false} />
                <div className={`tw-w-9/12 tw-flex`}>
                  <DateAndText
                    className={`tw-w-10/12`}
                    isHome={true}
                    text={constants.UI.home}
                  />
                </div>
              </div>
              <a href={`#home`} className={`tw-w-full tw-h-full tw-absolute`} onClick={activeMenuItem} data-index={`18472019`} />
            </li>
            {dates}
          </ul>
        </div>
        }
      </div>
      <div
        className={`tw-w-full tw-h-10 tw-fixed tw-top-0 tw-left-0 tw-z-40 tw-bg-transparent tw-transform tw-transition tw-duration-300 tw-out-expo`}
        style={{
          boxShadow: `0px 7px 10px -1px rgba(0, 0, 0, 0.15)`,
          height: `${headerH}px`,
          transform: `translateY(${isBarOpen ? 0 : -headerH}px)`
        }}
      />
    </menu>
  )
}

export default MenuMobile
